export enum VolumeType {
  ACTUAL = 'ACTUAL',
  ESTIMATE = 'ESTIMATE',
  GENERATED_ESTIMATE = 'GENERATED_ESTIMATE'
}
